import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "./Header";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
} from "../ui/modal";
import { useIsMobile } from "../../hooks/useIsMobile";

interface ResponsiveFormHostProps {
  title: string;
  parentRoute: string;
  children: ReactNode;
}

export function ResponsiveFormHost({
  title,
  parentRoute,
  children,
}: ResponsiveFormHostProps) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleClose = () => {
    navigate(parentRoute);
  };

  if (isMobile) {
    return (
      <div className="min-h-screen bg-background flex flex-col">
        <Header title={title} onBack={handleClose} variant="prominent" />
        <main className="flex-1 px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
          {children}
        </main>
      </div>
    );
  }

  return (
    <Modal open onOpenChange={(open) => !open && handleClose()}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <div className="px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] md:px-0 md:pb-0">
          {children}
        </div>
      </ModalContent>
    </Modal>
  );
}
